import { useMutation } from '@tanstack/react-query';
import { extractTopic } from '@/api/extractTopic';
import type { ExtractRequest, ExtractResponse } from '@/types/extractedTopic';

export function useExtractTopic() {
  return useMutation<ExtractResponse, Error, ExtractRequest>({
    mutationFn: extractTopic,
  });
}
